import Product from '@/js/common/Domain/Factory/Product';
import TourProductObjectValue from '@/js/common/Domain/ObjectValue/TourProduct';
import RailwayFactory from './RailwayTourFactory';

export default class extends Product {
    constructor(data) {
        super(data);

        this.type = 'RailwayTourProduct';

        let element = data.railwayTour?.id || null;
        if (typeof element !== 'undefined') {
            this.id = element;
        }

        element = data.railwayTour;
        if (typeof element !== 'undefined') {
            this.railwayTour = new RailwayFactory(element);
        }

        return new TourProductObjectValue(this);
    }
}